import { BusinessValidationError, getErrorMessage } from '@repo/domain-service';
import type { BusinessValidationCode } from '@repo/domain-service';
import { isNetworkError } from '@repo/error';
import type { TestId } from '@repo/test-id';
import { toast } from '@repo/toast';

type BusinessCodeMessages = Partial<Record<BusinessValidationCode, string>>;

export const handleRepositoryError = (
  error: unknown,
  options: { fallback: string; testId: TestId; businessCodes?: BusinessCodeMessages }
): void => {
  if (isNetworkError(error)) throw error;
  if (error instanceof BusinessValidationError) {
    const message = options.businessCodes?.[error.code] ?? options.fallback;
    toast.danger(message, options.testId.append('errorToast'));
    return;
  }
  toast.danger(getErrorMessage(error, options.fallback), options.testId.append('errorToast'));
};
